import React, { useEffect, useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'

import { format } from 'date-fns'

import DatePicker from '@/Shared/DatePicker'
import { Typography } from '@material-tailwind/react'

export default function({ id, value, link, name, setData }) {
    const {
        auth: {
            user: { role }
        }
    } = usePage().props

    const [isEditing, setIsEditing] = useState(false)
    const [isEdited, setIsEdited] = useState(false)

    useEffect(() => {
        if (isEdited) {
            router.put(route('consumable.arrived.update', id), {
                [name]: value
            })

            setIsEdited(false)
        }
    }, [value, isEdited]);

    const handleClick = () => {
        if (!value || role === '1') {
            setIsEditing(!isEditing);
        }
    }

    return (
        <td className="border-t cursor-pointer" onClick={handleClick}>
            {isEditing ? (
                <DatePicker
                    label="Select Date"
                    name={name}
                    open={true}
                    date={value}
                    setDate={date => {
                        setData(prev => ({
                            ...prev,
                            [name]: String(date).toString()
                        }))

                        setIsEdited(true)
                    }}
                />
            ) : value ? (
                <Link
                    tabIndex="-1"
                    onClick={(e) => {
                        if (role === '1') {
                            e.preventDefault();
                        }
                    }}
                    href={link}
                    className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                >
                    {format(value, 'MM/dd/yyyy')}
                </Link>
            ) : (
                <Typography
                    variant="small"
                    color="gray"
                    className="mt-2 flex items-center gap-1 font-normal"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="-mt-px h-4 w-4"
                    >
                        <path
                            fillRule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                            clipRule="evenodd"
                        />
                    </svg>
                    Click here to add arrival date!
                </Typography>
            )}
        </td>
    )
}
